export default "__VITE_ASSET__B90gc3XT__"